import { Form } from "@circle-react-uikit/Form";
import snakeCase from "lodash/snakeCase";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import type { FlaggedContentableType } from "@/react/types";

import { ActionSplitButton } from "./ActionSplitButton";
import { RejectWithReasonTextArea } from "./RejectWithReasonTextArea";

interface RejectWithReasonActionsProps {
  i18nRoot: string;
  isRejecting?: boolean;
  onReject: (reason: string | null) => void;
  type: FlaggedContentableType;
}

export const RejectWithReasonActions = ({
  i18nRoot,
  onReject,
  isRejecting,
  type,
}: RejectWithReasonActionsProps) => {
  const [reason, setReason] = useState<string>();

  return (
    <div className="flex flex-col">
      <Form onSubmit={() => onReject(reason || null)}>
        <Form.Item
          name="reason"
          label={t([i18nRoot, "moderation_note"])}
          className="w-full !p-0"
          hideDescription
          hideBorder
        >
          <RejectWithReasonTextArea
            i18nRoot={i18nRoot}
            onReasonChange={setReason}
          />
        </Form.Item>
      </Form>
      <div className="mt-6 flex justify-end gap-2">
        <ActionSplitButton
          disabled={isRejecting ?? false}
          options={[
            {
              label: t([i18nRoot, `reject_${snakeCase(type)}`]),
              value: "reject",
              onClick: () => onReject(reason ?? null),
            },
          ]}
          setSelectedAction={() => {}}
          variant="danger"
        />
      </div>
    </div>
  );
};
